import { useEffect, useState } from 'react'
import orderBy from 'lodash/orderBy'
import { db } from '../../config/firebase'
import mapPromoScheduleListItem from './mapPromoScheduleListItem'
import { PREMIUM_PROMO_SHOP_ID } from './promoScheduleConstants'

const PROMO_TYPE_BRAND = 'brandOffer'
const SUBSCRIPTION_ERROR_MESSAGE = 'Не вдалося завантажити список промо / акцій'

const usePromoSchedulesSubscription = () => {
  const [schedules, setSchedules] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const unsubscribe = db
      .collection('promoSchedules')
      .where('shopId', '==', PREMIUM_PROMO_SHOP_ID)
      .onSnapshot(
        (snapshot) => {
          const nextSchedules = orderBy(
            snapshot.docs
              .filter((doc) => doc.data()?.promoType === PROMO_TYPE_BRAND)
              .map((doc) => mapPromoScheduleListItem(doc.id, doc.data(), new Date())),
            ['statusSort', 'startedAtSort'],
            ['asc', 'desc']
          )

          setSchedules(nextSchedules)
          setError('')
          setIsLoading(false)
        },
        (snapshotError) => {
          console.error('[usePromoSchedulesSubscription] failed:', snapshotError)
          setError(snapshotError?.message || SUBSCRIPTION_ERROR_MESSAGE)
          setIsLoading(false)
        }
      )

    return () => unsubscribe()
  }, [])

  return {
    schedules,
    isLoading,
    error,
  }
}

export default usePromoSchedulesSubscription
